export default __webpack_public_path__ + "static/media/health-care.03835cd2.svg";